module.exports = __webpack_public_path__ + "img/广告-5 - 得陇望蜀.4f88ef1f.jpg";